<template>
  <v-row justify="space-around">
    <v-col cols="12">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h2 class="primary--text font-weght-bold pt-5 pl-2">
              {{ $t('display/advert:edit.labels.logs') }}
            </h2>

            <v-btn
              class="ma-2"
              outlined
              color="primary"
              @click="openAdvertLog()"
            >
              <v-icon class="mr-2">auto_stories</v-icon>
              {{ $t('common:media') }}
            </v-btn>

            <v-btn
              class="ma-2"
              outlined
              color="primary"
              @click="openDownloadLog()"
            >
              <v-icon class="mr-2">auto_stories</v-icon>
              {{ $t('display/advert:edit.labels.downloads') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="elevators.button">
          <v-col cols="12">
            <h2 class="primary--text font-weght-bold pt-5 pl-2">
              {{ $t('display/advert:edit.labels.button-elevator') }}
            </h2>
            <v-btn
                class="ma-2"
                outlined
                color="primary"
                v-for="elevator in elevators.button"
                :key="elevator.id"
                @click="openElevator(elevator.id)"
            >
              <v-icon class="mr-2">elevator</v-icon>
              {{ elevator.name }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="elevators.customer">
          <v-col cols="12">
            <h2 class="primary--text font-weght-bold pt-5 pl-2">
              {{ $t('display/advert:edit.labels.customer-elevator') }}
            </h2>
            <v-btn
                class="ma-2"
                outlined
                color="primary"
                v-for="elevator in elevators.customer"
                :key="elevator.id"
                @click="openElevator(elevator.id)"
            >
              <v-icon class="mr-2">elevator</v-icon>
              {{ elevator.name }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import Advert from '@/modules/display/data/advert';
import ElevatorService from '@/modules/display/services/elevator-service';

export default {
  name: 'FunctionTab',
  props: {
    advert: {
      type: Object,
      default: new Advert()
    }
  },
  data() {
    return {
      elevators: {}
    }
  },
  methods: {
    gotoPath(path, id) {
      let url = this.$router.resolve({
        name: path
      });

      const link = document.createElement('a');
      link.href = url.href + '?resourceId=' + id;
      link.target = '_blank';
      link.click();

      URL.revokeObjectURL(link.href);
    },
    openAdvertLog() {
      this.gotoPath('Advert Logs', this.advert.id);
    },
    openDownloadLog() {
      let mediaId = this.advert.media.id;
      if (!mediaId) {
        mediaId = '';
      }
      this.gotoPath('Download Logs', mediaId);
    },
    openElevator(elevatorId) {
      this.gotoPath('Elevator table', elevatorId);
    }
  },
  mounted() {
    ElevatorService.loadRelatedElevator(
        this.advert.id,
        !this.advert.customer ? '00000000-0000-0000-0000-000000000000' : this.advert.customer,
        (response) => {
          this.elevators = response.data;
        }
    )

  }
}
</script>